"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayLoadSortBy = void 0;
exports.PayLoadSortByFromJSON = PayLoadSortByFromJSON;
exports.PayLoadSortByFromJSONTyped = PayLoadSortByFromJSONTyped;
exports.PayLoadSortByToJSON = PayLoadSortByToJSON;
exports.PayLoadSortByToJSONTyped = PayLoadSortByToJSONTyped;
/**
 * Sort by this field for PayLoad
 * @export
 * @enum {string}
 */
var PayLoadSortBy;
(function (PayLoadSortBy) {
    PayLoadSortBy["Id"] = "id";
    PayLoadSortBy["Title"] = "title";
    PayLoadSortBy["CreatedTs"] = "created_ts";
    PayLoadSortBy["ModifiedTs"] = "modified_ts";
    PayLoadSortBy["TimeFrom"] = "time_from";
    PayLoadSortBy["TimeUntil"] = "time_until";
})(PayLoadSortBy || (exports.PayLoadSortBy = PayLoadSortBy = {}));
function PayLoadSortByFromJSON(json) {
    return PayLoadSortByFromJSONTyped(json, false);
}
function PayLoadSortByFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function PayLoadSortByToJSON(value) {
    return PayLoadSortByToJSONTyped(value, false);
}
function PayLoadSortByToJSONTyped(value, ignoreDiscriminator = false) {
    return value;
}
